<template>
  <li :class="liClass">
    <nuxt-link
      v-if="!footer"
      :to="`/${$route.params.subpage}/${link}`"
      :class="itemClass"
      >{{ label }}</nuxt-link
    >
    <nuxt-link
      v-else
      v-scroll-to="'#top'"
      :to="`/${$route.params.subpage}/${link}`"
      :class="itemClass"
      >{{ label }}</nuxt-link
    >
  </li>
</template>

<script>
const liClasses = {
  header: 'mr-3',
  footer: 'lg:w-1/2 mb-1'
}
const itemClasses = {
  header:
    'text-center font-bold inline-block uppercase text-blue-800 border-transparent border-b-2 rounded-b-none hover:border-blue-200 sm:py-1 my-1 sm:my-0',
  footer:
    'inline-block text-white border-b border-blue-900 hover:border-blue-200'
}

export default {
  props: ['label', 'link', 'footer'],
  // scrollToTop: scrollPosition,
  computed: {
    // scrollPosition() {
    //   return this.footer == false ? true : false
    // },
    liClass() {
      return liClasses[this.footer ? 'footer' : 'header']
    },
    itemClass() {
      return itemClasses[this.footer ? 'footer' : 'header']
    }
  }
}
</script>

<style scoped>
.nuxt-link-active {
  @apply border-blue-800;
}
.footer .nuxt-link-active {
  @apply border-blue-400;
}
</style>
